import { render, staticRenderFns } from "./ThirdPartyBalanceReport.vue?vue&type=template&id=db6897a8&scoped=true&"
import script from "./ThirdPartyBalanceReport.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyBalanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6897a8",
  null
  
)

export default component.exports